// src/pages/PortalSaaS/modals/OnboardingModal.js
import React, { useState, useEffect } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../firebase';

const OnboardingModal = ({ user, onComplete }) => {
    // ESTADOS DO FUNIL
    const [loadingInvite, setLoadingInvite] = useState(true);
    const [step, setStep] = useState(1);
    const [accountType, setAccountType] = useState(null); // 'PJ' ou 'ACADEMICO'
    // --- ESTADOS DE CONVITE ---
    const [pendingInvite, setPendingInvite] = useState(null);

    
    const [isProcessing, setIsProcessing] = useState(false);
    
    // ESTADOS DE CONSENTIMENTO ATOMIZADO (LGPD)
    const [acceptedTerms, setAcceptedTerms] = useState(false); 
    const [acceptedTelemetry, setAcceptedTelemetry] = useState(true); // Recomendado, mas opcional
    const [acceptedMarketingPhone, setAcceptedMarketingPhone] = useState(false);
    const [acceptedMarketingEmail, setAcceptedMarketingEmail] = useState(false);

    // Rastreador de Convites (Roda assim que a modal abre)
    useEffect(() => {
        const verificarConvites = async () => {
            try {
                const checkInviteFn = httpsCallable(functions, 'checkPendingInvites');
                const response = await checkInviteFn();
                if (response.data.hasInvite) {
                    setPendingInvite(response.data.inviteData);
                    setStep(0);
                }
            } catch (e) {
                console.error("Erro ao checar convites:", e);
            } finally {
                setLoadingInvite(false); // <--- Finaliza o carregamento
            }
        };
        verificarConvites();
    }, []);

    // Função para Aceitar o Convite
    const handleAcceptInvite = async () => {
        setIsProcessing(true); 
        try {
            const acceptInviteFn = httpsCallable(functions, 'acceptInvite');
            
            // --- MUDANÇA: Enviando o Payload LGPD para a Cloud Function ---
            await acceptInviteFn({ 
                consentimentos: { 
                    marketingTelefone: acceptedMarketingPhone, 
                    marketingEmail: acceptedMarketingEmail 
                } 
            });
            // ---------------------------------------------------------------

            alert("✅ Convite aceito com sucesso! Bem-vindo à equipe.");
            
            // Como não temos um slug gerado aqui, mandamos um sinal para o Shell recarregar os Workspaces
            if (onComplete) {
                onComplete("INVITE_ACCEPTED"); 
            } else {
                window.location.reload(); // Fallback caso onComplete não exista
            }
        } catch (error) {
            alert("Falha ao aceitar o convite: " + error.message);
            setIsProcessing(false);
        }
    };

    // ESTADOS DE DADOS
    const [formData, setFormData] = useState({ 
        cnpj: '', 
        cpf: '', 
        telefone: '', // Novo campo obrigatório para Asaas e CRM
        slug: '',
        nome: user?.displayName || '',
        instituicao: '' // Para estudantes
    });

    // ESTADOS DO CARTÃO DE CRÉDITO (CHECKOUT TRANSPARENTE)
    const [cardData, setCardData] = useState({
        numero: '',
        titular: '',
        validade: '',
        cvv: ''
    });

    // === ESTADOS DE PREÇO (CAIXA PRETA API) ===
    const [precosAtivos, setPrecosAtivos] = useState({ matriz: '---', estudante: '---' });

    useEffect(() => {
        const buscarPrecos = async () => {
            try {
                // A função do Back-end que esconde os preços do F12
                const getPrecos = httpsCallable(functions, 'getPrecosAtuais');
                const response = await getPrecos();
                
                // Mapeando a resposta segura
                setPrecosAtivos({
                    matriz: response.data.valorMatriz,
                    estudante: response.data.valorEstudante
                });
            } catch (error) {
                console.error("Falha silenciosa ao buscar tabela de preços", error);
            }
        };
        buscarPrecos();
    }, []);


    
    // ============================================

    // --- FUNÇÕES DE MÁSCARA ---
    const formatCNPJ = (value) => {
        const nums = value.replace(/\D/g, "");
        return nums.replace(/^(\d{2})(\d)/, "$1.$2").replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3").replace(/\.(\d{3})(\d)/, ".$1/$2").replace(/(\d{4})(\d)/, "$1-$2").substring(0, 18);
    };

    const formatCPF = (value) => {
        const nums = value.replace(/\D/g, "");
        return nums.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})\.(\d{3})(\d)/, "$1.$2.$3").replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4").substring(0, 14);
    };

    const formatCardNumber = (value) => {
        const nums = value.replace(/\D/g, "");
        return nums.replace(/(\d{4})(?=\d)/g, "$1 ").substring(0, 19);
    };

    const formatExpiry = (value) => {
        const nums = value.replace(/\D/g, "");
        return nums.replace(/^(\d{2})(\d)/, "$1/$2").substring(0, 5);
    };
    const formatPhone = (value) => {
        const nums = value.replace(/\D/g, "");
        return nums.replace(/^(\d{2})(\d)/, "($1) $2").replace(/(\d{4,5})(\d{4})$/, "$1-$2").substring(0, 15);
    };

    // --- NAVEGAÇÃO E AÇÃO ---
    const handleSelectType = (type) => {
        setAccountType(type);
        setStep(2);
    };

    const handleStartOnboarding = async () => {
        // Validações Base
        if (accountType === 'PJ' && !formData.cnpj) return alert("CNPJ é obrigatório para contas corporativas.");
        if (accountType === 'ACADEMICO' && !formData.instituicao) return alert("O Nome da Instituição é obrigatório.");
        if (!formData.cpf) return alert("O CPF é obrigatório para identificação financeira.");
        if (!formData.telefone || formData.telefone.replace(/\D/g, '').length < 10) return alert("O Celular/WhatsApp é obrigatório e deve conter o DDD.");
        
        // Validação Cartão
        if (cardData.numero.length < 15 || cardData.cvv.length < 3 || !cardData.validade) {
            return alert("Por favor, preencha os dados do Cartão de Crédito corretamente.");
        }
        
        setIsProcessing(true);
        try {
            // FASE 8: PREPARAÇÃO DO CARTÃO PARA A CLOUD FUNCTION SEGURA
            const [expMonth, expYearShort] = cardData.validade.split('/');
            const expYear = `20${expYearShort}`;

            const creditCard = {
                holderName: cardData.titular,
                number: cardData.numero.replace(/\s/g, ''),
                ccv: cardData.cvv,
                expiryMonth: expMonth,
                expiryYear: expYear
            };

            const creditCardHolderInfo = {
                name: cardData.titular,
                email: user?.email || "cadastro@pts.dev.br",
                cpfCnpj: formData.cpf.replace(/\D/g, ""),
                postalCode: "01001000",
                addressNumber: "1",
                phone: formData.telefone.replace(/\D/g, "")
            };

            // Envio do Payload Seguro para o Backend (O HTTPS garante o túnel SSL/TLS)
            const processOnboarding = httpsCallable(functions, 'processOnboardingIdentitario');
            
            const response = await processOnboarding({
                tipoConta: accountType,
                cnpj: formData.cnpj || formData.cpf, 
                cpfDigitado: formData.cpf,
                telefoneDigitado: formData.telefone,
                nomeUsuario: formData.nome, 
                customSlug: formData.slug,
                instituicao: formData.instituicao,
                cartaoCredito: creditCard, // Enviando para tokenização e descarte no Back-end
                titularCartao: creditCardHolderInfo,
                consentimentos: {
                    termos: acceptedTerms,
                    telemetria: acceptedTelemetry,
                    marketingTelefone: acceptedMarketingPhone,
                    marketingEmail: acceptedMarketingEmail
                }
            });

            const { status, role, isOwner, slugGerado } = response.data;

            if (status === "SUCCESS") {
                alert(`✅ Identidade e Pagamento Confirmados! Acesso ativado.`);
                onComplete(slugGerado);
            }
        } catch (error) {
            console.error("Erro Onboarding:", error);
            alert("Falha na Validação: " + (error.message || "Verifique os dados ou a validade do cartão de crédito."));
        } finally {
            setIsProcessing(false);
        }
    };

    // ==========================================
    // RENDERIZAÇÃO: STEP 1 (ESCOLHA DE PERFIL)
    // ==========================================
    // ==========================================
    // RENDERIZAÇÃO: STEP 0 (CONVITE PENDENTE)
    // ==========================================
    if (loadingInvite) return (
        <div className="pts-modal-glass">
            <div className="pts-modal-box">Carregando convites e permissões...</div>
        </div>
    );
    if (step === 0 && pendingInvite) {
        return (
            <div className="pts-modal-glass">
                <div className="pts-modal-box" style={{ maxWidth: '500px', textAlign: 'center', padding: '40px 20px' }}>
                    <div style={{ fontSize: '3rem', marginBottom: '15px' }}>🤝</div>
                    <h2 style={{ color: '#0f172a', fontSize: '1.8rem', fontWeight: '800', marginBottom: '10px' }}>Você foi convidado!</h2>
                    
                    <p style={{ color: '#475569', fontSize: '1rem', lineHeight: '1.5', marginBottom: '20px' }}>
                        A organização <strong style={{color: '#0369a1'}}>{pendingInvite.nomeOrg}</strong> designou você como <strong>{pendingInvite.role}</strong> na plataforma.
                    </p>

                    {/* CHECKBOX DE COMPLIANCE LGPD PARA O CONVIDADO */}
                    <div style={{ textAlign: 'left', background: '#f8fafc', padding: '15px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '25px' }}>
                        <label style={{ display: 'flex', gap: '12px', cursor: 'pointer' }}>
                            <input type="checkbox" checked={acceptedTerms} onChange={e => setAcceptedTerms(e.target.checked)} style={{ minWidth: '18px', height: '18px' }} />
                            <span style={{ fontSize: '0.85rem', color: '#0f172a', lineHeight: '1.4' }}>
                                Eu aceito os <a href="/termos" target="_blank" style={{color:'#0369a1'}}>Termos de Uso</a> e a <a href="/privacidade" target="_blank" style={{color:'#0369a1'}}>Política de Privacidade</a> da PTS.
                            </span>
                        </label>
                    </div>
                    
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        <button 
                            className="pts-btn-primary" 
                            onClick={handleAcceptInvite} 
                            disabled={isProcessing || !acceptedTerms} // TRAVA O BOTÃO SE NÃO ACEITAR
                            style={{ 
                                padding: '15px', fontSize: '1rem', 
                                background: !acceptedTerms ? '#cbd5e1' : '#10b981', 
                                color: 'white', border: 'none', borderRadius: '8px', 
                                cursor: !acceptedTerms ? 'not-allowed' : 'pointer' 
                            }}
                        >
                            {isProcessing ? "PROCESSANDO..." : "ACEITAR CONVITE E ENTRAR"}
                        </button>
                        
                        <button className="pts-btn-outline" onClick={() => setStep(1)} disabled={isProcessing}>
                            NÃO, QUERO CRIAR MEU PRÓPRIO LABORATÓRIO
                        </button>
                    </div>
                </div>
            </div>
        );
    }
    if (step === 1) {
        return (
            <div className="pts-modal-glass">
                <div className="pts-modal-box" style={{ maxWidth: '700px' }}>
                    <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                        <h2 style={{ color: '#0f172a', fontSize: '1.8rem', fontWeight: '800' }}>Como você pretende utilizar a PTS?</h2>
                        <p style={{ color: '#64748b' }}>Selecione o seu perfil para adequarmos as ferramentas, normas e planos da plataforma.</p>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                        {/* CARD CORPORATIVO */}
                        <div 
                            onClick={() => handleSelectType('PJ')}
                            style={{ border: '2px solid #e2e8f0', borderRadius: '16px', padding: '30px', cursor: 'pointer', transition: '0.2s', background: '#fff' }}
                            onMouseOver={e => { e.currentTarget.style.borderColor = '#0369a1'; e.currentTarget.style.background = '#f0f9ff'; }}
                            onMouseOut={e => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.background = '#fff'; }}
                        >
                            <div style={{ fontSize: '2.5rem', marginBottom: '15px' }}>🏢</div>
                            <h3 style={{ margin: '0 0 10px 0', color: '#0f172a' }}>Uso Corporativo</h3>
                            <p style={{ fontSize: '0.85rem', color: '#64748b', margin: 0 }}>Laboratórios de qualidade, concessionárias e construtoras. Exige CNPJ válido.</p>
                            <div style={{ marginTop: '20px', fontSize: '0.8rem', fontWeight: 'bold', color: '#0369a1' }}>→ Geração de Laudos Oficiais Liberada</div>
                        </div>

                        {/* CARD ACADÊMICO */}
                        <div 
                            onClick={() => handleSelectType('ACADEMICO')}
                            style={{ border: '2px solid #e2e8f0', borderRadius: '16px', padding: '30px', cursor: 'pointer', transition: '0.2s', background: '#fff' }}
                            onMouseOver={e => { e.currentTarget.style.borderColor = '#16a34a'; e.currentTarget.style.background = '#dcfce7'; }}
                            onMouseOut={e => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.background = '#fff'; }}
                        >
                            <div style={{ fontSize: '2.5rem', marginBottom: '15px' }}>🎓</div>
                            <h3 style={{ margin: '0 0 10px 0', color: '#0f172a' }}>Pesquisa e Estudo</h3>
                            <p style={{ fontSize: '0.85rem', color: '#64748b', margin: 0 }}>Estudantes, pesquisadores e universidades. Acesso focado no Perito Digital (IA).</p>
                            <div style={{ marginTop: '20px', fontSize: '0.8rem', fontWeight: 'bold', color: '#16a34a' }}>→ Emissão de PDF Desativada (Proteção PI)</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Lógica para definir o preço a exibir com base no accountType selecionado
    const precoExibicao = accountType === 'PJ' ? precosAtivos.matriz : precosAtivos.estudante;
    const precoFormatado = precoExibicao !== '---' ? precoExibicao.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '---';

    // ==========================================
    // RENDERIZAÇÃO: STEP 2 (DADOS E CARTÃO)
    // ==========================================
    return (
        <div className="pts-modal-glass">
            <div className="pts-modal-box" style={{ maxWidth: '550px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', padding: '20px' }}>
                {/* CABEÇALHO FIXO */}
                <div style={{ position: 'relative', textAlign: 'center', marginBottom: '15px' }}>
                    <button onClick={() => setStep(1)} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#64748b', position: 'absolute', top: '0', left: '0' }}>←</button>
                    <div style={{ fontSize: '0.8rem', color: accountType === 'PJ' ? '#0369a1' : '#16a34a', fontWeight: 'bold', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '1px' }}>
                        {accountType === 'PJ' ? 'Ativação Corporativa' : 'Ativação Acadêmica'}
                    </div>
                    <h2 style={{ color: '#0f172a', fontSize: '1.5rem', fontWeight: '800', margin: 0 }}>Dados e Pagamento</h2>
                </div>

                {/* CORPO ROLÁVEL */}
                <div className="pts-form-step" style={{ flex: 1, overflowY: 'auto', paddingRight: '10px' }}>
                    
                    {/* --- DADOS IDENTITÁRIOS DINÂMICOS --- */}
                    {accountType === 'PJ' ? (
                        <>
                            <label className="pts-label">CNPJ da Empresa (Matriz)</label>
                            <input className="pts-dynamic-input" placeholder="00.000.000/0000-00" value={formData.cnpj} onChange={e => setFormData({...formData, cnpj: formatCNPJ(e.target.value)})} />
                        </>
                    ) : (
                        <>
                            <label className="pts-label">Nome da Instituição ou Universidade</label>
                            <input className="pts-dynamic-input" placeholder="Ex: USP, UFSC, FATEC..." value={formData.instituicao} onChange={e => setFormData({...formData, instituicao: e.target.value})} />
                        </>
                    )}
                    
                    <label className="pts-label">{accountType === 'PJ' ? 'Seu CPF (Sócio-Proprietário)' : 'Seu CPF (Titular do Cartão)'}</label>
                    <input className="pts-dynamic-input" placeholder="000.000.000-00" value={formData.cpf} onChange={e => setFormData({...formData, cpf: formatCPF(e.target.value)})} />
                    <label className="pts-label">Seu Celular / WhatsApp</label>
                    <input className="pts-dynamic-input" placeholder="(00) 00000-0000" value={formData.telefone} onChange={e => setFormData({...formData, telefone: formatPhone(e.target.value)})} />
                    <label className="pts-label">Escolha sua URL de Acesso</label>
                    <div className="pts-vanity-url">
                        <span>pts.dev.br/</span>
                        <input placeholder="seu-endereco" value={formData.slug} onChange={(e) => setFormData({...formData, slug: e.target.value})} />
                    </div>

                    {/* --- CHECKOUT TRANSPARENTE (CARTÃO DE CRÉDITO) --- */}
                    <div style={{ borderTop: '1px solid #e2e8f0', marginTop: '20px', paddingTop: '20px' }}>
                        <h4 style={{ margin: '0 0 15px 0', color: '#0f172a' }}>💳 Dados de Pagamento Seguro</h4>
                        
                        <input 
                            className="pts-dynamic-input" 
                            style={{ marginBottom: '10px' }} 
                            placeholder="Número do Cartão" 
                            value={cardData.numero} 
                            onChange={e => setCardData({...cardData, numero: formatCardNumber(e.target.value)})} 
                            maxLength="19"
                        />
                        <input 
                            className="pts-dynamic-input" 
                            style={{ marginBottom: '10px' }} 
                            placeholder="Nome impresso no Cartão" 
                            value={cardData.titular} 
                            onChange={e => setCardData({...cardData, titular: e.target.value.toUpperCase()})} 
                        />
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                            <input 
                                className="pts-dynamic-input" 
                                placeholder="Validade (MM/AA)" 
                                value={cardData.validade} 
                                onChange={e => setCardData({...cardData, validade: formatExpiry(e.target.value)})} 
                                maxLength="5"
                            />
                            <input 
                                className="pts-dynamic-input" 
                                type="password" 
                                placeholder="CVV" 
                                value={cardData.cvv} 
                                onChange={e => setCardData({...cardData, cvv: e.target.value.replace(/\D/g, '').substring(0, 4)})} 
                            />
                        </div>
                    </div>

                    {/* --- BLOCO FINANCEIRO DE IMPACTO DINÂMICO --- */}
                    <div style={{ background: accountType === 'PJ' ? '#f0f9ff' : '#dcfce7', padding: '20px', borderRadius: '16px', border: `1px solid ${accountType === 'PJ' ? '#bae6fd' : '#86efac'}`, marginTop: '20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                            <span style={{ fontSize: '0.85rem', color: '#0f172a' }}>{accountType === 'PJ' ? 'Assinatura Matriz' : 'Assinatura Acadêmica'}</span>
                            <span style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#0f172a' }}>R$ {precoFormatado}</span>
                        </div>
                        <hr style={{ border: 'none', borderTop: '1px dashed #cbd5e1', margin: '12px 0' }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ fontWeight: '800', color: '#0f172a' }}>Total Mensal:</span>
                            <span style={{ fontWeight: '800', fontSize: '1.2rem', color: '#0f172a' }}>R$ {precoFormatado}</span>
                        </div>
                    </div>
                    {/* --- CHECKBOXES ATOMIZADOS DE ACEITE (COMPLIANCE LGPD) --- */}
                    <div style={{ marginTop: '20px', textAlign: 'left', background: '#f8fafc', padding: '15px', borderRadius: '12px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        
                        <label style={{ display: 'flex', gap: '12px', cursor: 'pointer' }}>
                            <input type="checkbox" checked={acceptedTerms} onChange={e => setAcceptedTerms(e.target.checked)} style={{ marginTop: '2px', minWidth: '18px', height: '18px' }} />
                            <span style={{ fontSize: '0.85rem', color: '#0f172a', lineHeight: '1.4', fontWeight: 'bold' }}>
                                Concordo com os <a href="/termos-e-condicoes" target="_blank" style={{ color: '#0369a1', textDecoration: 'underline' }}>termos e condições</a> e com a <a href="/politica-de-privacidade" target="_blank" style={{ color: '#0369a1', textDecoration: 'underline' }}>Política de Privacidade</a>. (Obrigatório)
                            </span>
                        </label>

                        <label style={{ display: 'flex', gap: '12px', cursor: 'pointer' }}>
                            <input type="checkbox" checked={acceptedTelemetry} onChange={e => setAcceptedTelemetry(e.target.checked)} style={{ marginTop: '2px', minWidth: '18px', height: '18px' }} />
                            <span style={{ fontSize: '0.8rem', color: '#475569', lineHeight: '1.4' }}>
                                Autorizo a coleta de <strong>Telemetria</strong> de minhas prensas e arquivos operacionais, permitindo que a PTS identifique padrões analíticos, preveja falhas mecânicas e aprimore as memórias de cálculo da IA.
                            </span>
                        </label>

                        <label style={{ display: 'flex', gap: '12px', cursor: 'pointer' }}>
                            <input type="checkbox" checked={acceptedMarketingPhone} onChange={e => setAcceptedMarketingPhone(e.target.checked)} style={{ marginTop: '2px', minWidth: '18px', height: '18px' }} />
                            <span style={{ fontSize: '0.8rem', color: '#475569', lineHeight: '1.4' }}>
                                Aceito receber comunicações, notícias e promoções da Primo Trade Solutions por Telefone, WhatsApp e aplicativos de mensagem instantânea.
                            </span>
                        </label>

                        <label style={{ display: 'flex', gap: '12px', cursor: 'pointer' }}>
                            <input type="checkbox" checked={acceptedMarketingEmail} onChange={e => setAcceptedMarketingEmail(e.target.checked)} style={{ marginTop: '2px', minWidth: '18px', height: '18px' }} />
                            <span style={{ fontSize: '0.8rem', color: '#475569', lineHeight: '1.4' }}>
                                Aceito receber comunicações, notícias e promoções da Primo Trade Solutions por e-mail.
                            </span>
                        </label>
                    </div>

                    <button 
                        className={`pts-btn-launch ${(!acceptedTerms || isProcessing) ? 'disabled' : ''}`} 
                        disabled={!acceptedTerms || isProcessing} 
                        onClick={handleStartOnboarding}
                        style={{ 
                            marginTop: '20px', 
                            background: !acceptedTerms ? '#cbd5e1' : (accountType === 'PJ' ? '#0f172a' : '#16a34a'),
                            cursor: !acceptedTerms ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {isProcessing ? "VALIDANDO CARTÃO..." : "ATIVAR MINHA ESTAÇÃO DIGITAL"}
                    </button>
                    
                    <p style={{ fontSize: '0.7rem', color: '#94a3b8', textAlign: 'center', marginTop: '15px' }}>
                        🔒 Pagamento criptografado de ponta a ponta. Recorrência processada por <strong>Asaas</strong>. <br/>
                        Você pode cancelar a qualquer momento em seu painel.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default OnboardingModal;